import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import InvoiceDetailsPage from '../resources/Invoices/pages/InvoiceDetailsPage';
import CreateInvoicePage from '../resources/Invoices/pages/CreateInvoicePage';
import CreditNoteDetailsPage from '../resources/creditNotes/pages/CreditNoteDetailsPage';
import CustomerAccessLayout from '../resources/customers/components/CustomerAccessLayout';
import CustomerDetailsPage from '../resources/customers/pages/CustomerDetailsPage';
import EditCustomerPage from '../resources/customers/pages/EditCustomerPage';
import CustomerListPage from '../resources/customers/pages/CustomerListPage';
import CreateCustomersPage from '../resources/customers/pages/CreateCustomersPage';
import SupplierListPage from '../resources/suppliers/pages/SupplierListPage';
import SupplierDetailsPage from '../resources/suppliers/pages/SupplierDetailsPage';
import EditSupplierPage from '../resources/suppliers/pages/EditSupplierPage';
import CreateSuppliersPage from '../resources/suppliers/pages/CreateSuppliersPage';
import SupplierAccessLayout from '../resources/suppliers/components/SupplierAccessLayout';
import SettingsPage from '../resources/settings/pages/SettingsPage';
import BulkUploadListPage from '../resources/bulkUpload/pages/BulkUploadListPage';
import CreateCreditNotePage from '../resources/creditNotes/pages/CreateCreditNotePage';
import BusinessProfileListPage from '../resources/businessProfiles/pages/BusinessProfileListPage';
import BusinessProfileDetailsPage from '../resources/businessProfiles/pages/BusinessProfileDetailsPage';
import EditBusinessProfilePage from '../resources/businessProfiles/pages/EditBusinessProfilePage';
import BusinessProfileAccessLayout from '../resources/businessProfiles/components/BusinessProfileAccessLayout';
import MisDashboardPage from '../resources/misDashboard/pages/MisDashboardPage';
import DocumentReportPage from '../resources/documentReports/pages/DocumentReportPage';
import DocumentReportAccessLayout from '../resources/documentReports/components/DocumentReportAccessLayout';
import VATReportPage from '../resources/documentReports/pages/VATReportPage';
import VATReportAccessLayout from '../resources/documentReports/components/VATReportAccessLayout';
import ProductListPage from '../resources/products/pages/ProductListPage';
import ProductAccessLayout from '../resources/products/components/ProductAccessLayout';
import DocumentListPage from '../resources/DocumentListPage';
import PdfDataExtractionListPage from '../resources/pdfDataExtraction/pages/PdfDataExtractionListPage';
import ResubmitInvoicePage from '../resources/Invoices/pages/ResubmitInvoicePage';
import ResubmitCreditNotePage from '../resources/creditNotes/pages/ResubmitCreditNotePage';
import ProformaInvoiceListPage from '../resources/proformaInvoices/pages/ProformaInvoiceListPage';
import ProformaInvoiceDetailsPage from '../resources/proformaInvoices/pages/ProformaInvoiceDetailsPage';
import CreateProformaInvoicePage from '../resources/proformaInvoices/pages/CreateProformaInvoicePage';
import EditProformaInvoicePage from '../resources/proformaInvoices/pages/EditProformaInvoicePage';
import SalesDocumentsAccessLayout from '../resources/Invoices/components/SalesDocumentsAccessLayout';
import SalesInvoiceReadLayout from '../resources/Invoices/components/SalesInvoiceReadLayout';
import SalesCreditNoteReadLayout from '../resources/creditNotes/components/SalesCreditNoteReadLayout';
import ProformaAccessLayout from '../resources/proformaInvoices/components/ProformaAccessLayout';
import SalesInvoiceRegisterAccessLayout from '../resources/salesInvoiceRegister/components/SalesInvoiceRegisterAccessLayout';
import SalesInvoiceRegisterListPage from '../resources/salesInvoiceRegister/pages/SalesInvoiceRegisterListPage';
import CreateSalesInvoiceRegisterPage from '../resources/salesInvoiceRegister/pages/CreateSalesInvoiceRegisterPage';
import SalesInvoiceRegisterDetailsPage from '../resources/salesInvoiceRegister/pages/SalesInvoiceRegisterDetailsPage';
import EditSalesInvoiceRegisterPage from '../resources/salesInvoiceRegister/pages/EditSalesInvoiceRegisterPage';
import CreateSalesCreditNoteRegisterPage from '../resources/salesInvoiceRegister/pages/CreateSalesCreditNoteRegisterPage';
import SalesCreditNoteRegisterDetailsPage from '../resources/salesInvoiceRegister/pages/SalesCreditNoteRegisterDetailsPage';
import EditSalesCreditNoteRegisterPage from '../resources/salesInvoiceRegister/pages/EditSalesCreditNoteRegisterPage';
import PurchaseInvoiceRegisterAccessLayout from '../resources/purchaseInvoiceRegister/components/PurchaseInvoiceRegisterAccessLayout';
import PurchaseInvoiceRegisterListPage from '../resources/purchaseInvoiceRegister/pages/PurchaseInvoiceRegisterListPage';
import CreatePurchaseInvoiceRegisterPage from '../resources/purchaseInvoiceRegister/pages/CreatePurchaseInvoiceRegisterPage';
import PurchaseInvoiceRegisterDetailsPage from '../resources/purchaseInvoiceRegister/pages/PurchaseInvoiceRegisterDetailsPage';
import EditPurchaseInvoiceRegisterPage from '../resources/purchaseInvoiceRegister/pages/EditPurchaseInvoiceRegisterPage';
import CreatePurchaseCreditNoteRegisterPage from '../resources/purchaseInvoiceRegister/pages/CreatePurchaseCreditNoteRegisterPage';
import PurchaseCreditNoteRegisterDetailsPage from '../resources/purchaseInvoiceRegister/pages/PurchaseCreditNoteRegisterDetailsPage';
import EditPurchaseCreditNoteRegisterPage from '../resources/purchaseInvoiceRegister/pages/EditPurchaseCreditNoteRegisterPage';
import BulkUploadAcessLayout from '../resources/bulkUpload/components/BulkUploadAcessLayout';
import PurchaseDocumentsAccessLayout from '../resources/Invoices/components/PurchaseDocumentsAccessLayout';
import PurchaseInvoiceReadLayout from '../resources/Invoices/components/PurchaseInvoiceReadLayout';
import PurchaseCreditNoteReadLayout from '../resources/creditNotes/components/PurchaseCreditNoteReadLayout';
import PurchaseBulkUploadAccessLayout from '../resources/bulkUpload/components/PurchaseBulkUploadAccessLayout';
import RegisterBulkUploadAccessLayout from '../resources/bulkUpload/components/RegisterBulkUploadAccessLayout';
import ReconciliationPage from '../resources/reconciliation/pages/ReconciliationPage';

const AuthenticatedRoutes = () => {
  let configuredFeatures = [];
  configuredFeatures.push(
    <React.Fragment key={'dashboard'}>
      <Route path="/dashboard" element={<MisDashboardPage />} />
      <Route path="/mis-dashboard" element={<Navigate to="/dashboard" replace />} />
    </React.Fragment>,

    <React.Fragment key={'products'}>
      <Route path="/products" element={<ProductAccessLayout />}>
        <Route index element={<ProductListPage />} />
      </Route>
    </React.Fragment>,

    <React.Fragment key={'business-profiles'}>
      <Route path="/business-profiles" element={<BusinessProfileAccessLayout />}>
        <Route index element={<BusinessProfileListPage />} />
        <Route path=":profile_id" element={<BusinessProfileDetailsPage />} />
        <Route path=":profile_id/edit" element={<EditBusinessProfilePage />} />
      </Route>
    </React.Fragment>,

    <React.Fragment key={'customers'}>
      <Route path="/customers" element={<CustomerAccessLayout />}>
        <Route index element={<CustomerListPage />} />
        <Route path="create" element={<CreateCustomersPage />} />
        <Route path=":profile_id" element={<CustomerDetailsPage />} />
        <Route path=":profile_id/edit" element={<EditCustomerPage />} />
      </Route>
    </React.Fragment>,

    <React.Fragment key={'suppliers'}>
      <Route path="/suppliers" element={<SupplierAccessLayout />}>
        <Route index element={<SupplierListPage />} />
        <Route path="create" element={<CreateSuppliersPage />} />
        <Route path=":profile_id" element={<SupplierDetailsPage />} />
        <Route path=":profile_id/edit" element={<EditSupplierPage />} />
      </Route>
    </React.Fragment>,

    <React.Fragment key={'documents'}>
      <Route path="/sales/documents" element={<SalesDocumentsAccessLayout />}>
        <Route index element={<DocumentListPage isPurchase={false} />} />
        <Route path="invoices" element={<SalesInvoiceReadLayout />}>
          <Route path="create" element={<CreateInvoicePage isPurchase={false} />} />
          <Route path=":document_id/resubmit" element={<ResubmitInvoicePage isPurchase={false} />} />
          <Route path=":document_id" element={<InvoiceDetailsPage isPurchase={false} />} />
        </Route>
        <Route path="credit-notes" element={<SalesCreditNoteReadLayout />}>
          <Route path="create" element={<CreateCreditNotePage isPurchase={false} />} />
          <Route path=":document_id/resubmit" element={<ResubmitCreditNotePage isPurchase={false} />} />
          <Route path=":document_id" element={<CreditNoteDetailsPage isPurchase={false} />} />
        </Route>
      </Route>

      <Route path="/sales/proforma-invoices" element={<ProformaAccessLayout />}>
        <Route index element={<ProformaInvoiceListPage />} />
        <Route path="create" element={<CreateProformaInvoicePage />} />
        <Route path=":document_id/edit" element={<EditProformaInvoicePage />} />
        <Route path=":document_id" element={<ProformaInvoiceDetailsPage />} />
      </Route>
    </React.Fragment>,

    <React.Fragment key={'purchases'}>
      <Route path="/purchases/documents" element={<PurchaseDocumentsAccessLayout />}>
        <Route index element={<DocumentListPage isPurchase />} />
        <Route path="invoices" element={<PurchaseInvoiceReadLayout />}>
          <Route path="create" element={<CreateInvoicePage isPurchase />} />
          <Route path=":document_id/resubmit" element={<ResubmitInvoicePage isPurchase />} />
          <Route path=":document_id" element={<InvoiceDetailsPage isPurchase />} />
        </Route>
        <Route path="credit-notes" element={<PurchaseCreditNoteReadLayout />}>
          <Route path="create" element={<CreateCreditNotePage isPurchase />} />
          <Route path=":document_id/resubmit" element={<ResubmitCreditNotePage isPurchase />} />
          <Route path=":document_id" element={<CreditNoteDetailsPage isPurchase />} />
        </Route>
      </Route>
    </React.Fragment>,

    <React.Fragment key={'sales-invoice-register'}>
      <Route path="/sales-invoice-register" element={<SalesInvoiceRegisterAccessLayout />}>
        <Route index element={<SalesInvoiceRegisterListPage />} />
        <Route path="create" element={<CreateSalesInvoiceRegisterPage />} />
        <Route path="credit-notes/create" element={<CreateSalesCreditNoteRegisterPage />} />
        <Route path="credit-notes/:document_id/edit" element={<EditSalesCreditNoteRegisterPage />} />
        <Route path="credit-notes/:document_id" element={<SalesCreditNoteRegisterDetailsPage />} />
        <Route path=":document_id" element={<SalesInvoiceRegisterDetailsPage />} />
        <Route path=":document_id/edit" element={<EditSalesInvoiceRegisterPage />} />
      </Route>
    </React.Fragment>,

    <React.Fragment key={'purchase-invoice-register'}>
      <Route path="/purchase-invoice-register" element={<PurchaseInvoiceRegisterAccessLayout />}>
        <Route index element={<PurchaseInvoiceRegisterListPage />} />
        <Route path="create" element={<CreatePurchaseInvoiceRegisterPage />} />
        <Route path="credit-notes/create" element={<CreatePurchaseCreditNoteRegisterPage />} />
        <Route path="credit-notes/:document_id/edit" element={<EditPurchaseCreditNoteRegisterPage />} />
        <Route path="credit-notes/:document_id" element={<PurchaseCreditNoteRegisterDetailsPage />} />
        <Route path=":document_id" element={<PurchaseInvoiceRegisterDetailsPage />} />
        <Route path=":document_id/edit" element={<EditPurchaseInvoiceRegisterPage />} />
      </Route>
    </React.Fragment>,

    <React.Fragment key={'settings'}>
      <Route path={`/settings`} element={<SettingsPage />} />
      {/*TODO: permissions will be implemented later*/}
      {/*<Route path={`/settings/members/add`} element={<TeamPage />} />*/}
      {/*<Route path={`/settings/members/edit`} element={<TeamPage />} />*/}
    </React.Fragment>,

    <React.Fragment key={'bulk-upload'}>
      <Route path="/bulk-upload" element={<BulkUploadAcessLayout />}>
        <Route index element={<BulkUploadListPage />} />
      </Route>

      <Route path="/sales/bulk-upload" element={<Navigate to="/bulk-upload" replace />} />
      <Route path="/purchases/bulk-upload" element={<Navigate to="/bulk-upload" replace />} />
      <Route path="/register/bulk-upload" element={<Navigate to="/bulk-upload" replace />} />
    </React.Fragment>,

    <React.Fragment key={'pdf-data-extraction'}>
      <Route path={`/ai-tools/pdf-data-extraction`} element={<PdfDataExtractionListPage />} />
    </React.Fragment>,

    <React.Fragment key={'reporting-reconciliation'}>
      <Route path="reporting-reconciliation/document-report" element={<DocumentReportAccessLayout />}>
        <Route index element={<DocumentReportPage />} />
      </Route>
      <Route path={`reporting-reconciliation/vat-returns`} element={<VATReportAccessLayout />}>
        <Route index element={<VATReportPage />} />
      </Route>
      {/* PRD FR-A2: reconciliation has no dedicated permission code — any authenticated org user. */}
      <Route path="reporting-reconciliation/reconciliation" element={<ReconciliationPage />} />
    </React.Fragment>,
  );
  return configuredFeatures;
};
export default AuthenticatedRoutes;
